<template>
    <div class="my-container">
        <!--LEVELS-->
        <div class="difficulty-bar">
            <p class="text">{{ $t("word_list_component.difficulty_bar_title") }}</p>
            <Slider class="newSlider mt-5" :min="1" :max="9" :step="1" :format="sliderFormat" v-model="sliderValue" />
            <ul class="difficultyLevels">
                <li>{{ $t("word_list_component.beginner") }}</li>
                <li>{{ $t("word_list_component.high_beginner") }}</li>
                <li>{{ $t("word_list_component.intermediate") }}</li>
                <li>{{ $t("word_list_component.advanced") }}</li>
                <li>{{ $t("word_list_component.high_advanced") }}</li>
            </ul>
        </div>
        <!--LEVELS-->

        <div class="wordlist">
            <div style="height: 70px;" id="an-element"></div>
            <!-- <div @click="goQuiz" v-if="!$store.getters.getEditOption" class="go-quiz">
                <div class="text">
                    <div class="title">
                        Quiz'e Git
                    </div>
                    <div class="description">
                        Quiz ile seçilen kelimelere çalışabilirsiniz!
                    </div>
                </div>
                <div class="icon">
                    <Vue3Lottie :animationData="rocket" />
                </div>
            </div>-->
            <!--WORD LIST-->
            <div class="header">
                <div class="check-box-container">
                    <input type="checkbox" v-model="selectAll">
                    <span class="total-word-count"> {{ quizList.length }} {{ $t("word_list_component.word_count")
                        }}</span>
                </div>

                <span class="title">{{ $t("word_list_component.words") }}</span>
                <img class="sort-icon" src="~@/assets/SeriesDetail/filter-icon.svg" alt="">
                <div class="sort-methods">
                    <span @click="changeSortMethod('A-Z')">A-Z</span>
                    <span @click="changeSortMethod('Z-A')">Z-A</span>
                </div>
            </div>
            <div class="my-table">
                <tr @click="hovered_word = word" v-for="word in wordList2" :key="word.id">
                    <div class="grid">
                        <img v-if="!$store.getters.getEditOption" @click.stop="speak(word.phrase)" class="speak"
                            src="~@/assets/SeriesDetail/speak.svg" alt="">
                        <span class="phrase" :class="{ 'line-through': removedPhrases.includes(word.phrase) }">{{
                            word.phrase }}</span>
                    </div>
                    <div class="grid">
                        <span class="mean"
                            :class="{ 'line-through': removedPhrases.includes(word.phrase), 'en-mean': $i18n.locale == 'en' }">{{
                                word.mean
                            }}</span>
                    </div>
                    <div class="grid">
                        <div class="tooltip2" v-if="knownListPhrases.includes(word.phrase)">
                            <img src="~@/assets/SeriesDetail/known.svg" alt="">
                            <span class="tooltiptext">{{ $t("word_list_component.on_known_list") }}</span>
                        </div>
                        <div class="add-drop" v-if="!$store.getters.getEditOption">
                            <input @click="toggleRemove(word.phrase)" type="checkbox" :value="word.phrase" :id="word.id"
                                v-model="removedPhrases">
                            <label :for="word.id"></label>
                        </div>
                        <span @click="deleteWord(word)" role="button" v-if="$store.getters.getEditOption">
                            <i class="fas fa-trash-alt"></i>
                        </span>
                    </div>
                </tr>
            </div>
            <!--SAMPLE SENTENCE-->
            <div v-if="hovered_word.id" class="sample-sentence">
                <div class="plus-container">
                    <img v-if="$store.getters.getUserData" @click="$store.commit('setShowNewListModal', true)"
                        class="plus" src="@/assets/Quiz/plus-purple.svg" alt="">
                    <span @click="hovered_word = {}" class="take_break">
                        <img src="@/assets/Quiz/close.svg" alt="">
                    </span>
                    <span>{{ hovered_word.sampleSentence }}</span>
                </div>
                <addListModal v-if="$store.getters.getShowNewListModal">
                    <template v-slot:body>
                        <div class="my-column-flex">
                            <div v-for="list in $store.getters.getUserData.userWordLists" class="my-row-flex">
                                <span>{{ list.name }}</span>
                                <span @click="addList(list.id)" class="small-purple-button">
                                    {{ $t("quiz.add_list_button") }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <template v-slot:footer>
                    </template>
                </addListModal>
            </div>
            <!--SAMPLE SENTENCE-->
            <!--QUIZ BUTTON-->
            <div @click="goQuiz" v-if="!$store.getters.getEditOption" class="go-quiz">
                <div class="text">
                    <div class="title">
                        {{ $t("word_list_component.go_quiz_title") }}
                    </div>
                    <div class="description">
                        {{ $t("word_list_component.go_quiz_description") }}
                    </div>
                </div>
                <div class="icon">
                    <Vue3Lottie :animationData="rocket" />
                </div>
            </div>
            <!--QUIZ BUTTON-->
        </div>
        <!--WORD LIST-->
    </div>
    <div>
    </div>
</template>
<script>
import Slider from '@vueform/slider'
import axios from 'axios'
import { Vue3Lottie } from 'vue3-lottie'
import rocket from '@/assets/SeriesDetail/rocket.json'
import addListModal from "../Quiz/addListModal.vue";


export default {
    props: {
        wordList: {
            default: {}
        },
        sliderValueArg: {
            default: [5, 9],
        }
    },

    data() {
        return {
            removedPhrases: [],
            knownList: [],
            knownListPhrases: [],
            value: 20,
            success: false,
            rocket,
            sliderValue: [],
            sliderFormat: function (value) {
                return `Level ${value}`
            },
            selectAll: false,
            hovered_word: {}
        };
    },
    components: {
        Slider,
        Vue3Lottie,
        addListModal
    },
    created() {
        if (this.$store.getters.getUserData) {
            this.knownList = this.$store.getters.getUserData.knownList
            this.knownListPhrases = this.$store.getters.getUserData.knownList.map((item) => {
                if (item.phrase) {
                    return item.phrase
                }
            })

            // bilinenler listesinde tüm kelimeler listeden çıkmasın diye bu kontrolü yapıyoruz
            if (!this.$route.path.includes("hesabim") && !this.$route.path.includes("account")) {
                this.removedPhrases = this.knownListPhrases
            }
        }
        if (this.wordList) {
            this.sliderValue = this.sliderValueArg
            this.changeSortMethod('A-Z')
        }



    },
    beforeMount() {
    },
    methods: {
        changeSortMethod(methodInput) {
            if (methodInput == 'A-Z') {
                if (this.wordList.length > 1) {
                    this.wordList.sort(function (a, b) {
                        var textA = a.phrase.toUpperCase();
                        var textB = b.phrase.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                }
            } else if (methodInput == 'Z-A') {
                if (this.wordList.length > 1) {
                    this.wordList.sort(function (a, b) {
                        var textA = a.phrase.toUpperCase();
                        var textB = b.phrase.toUpperCase();
                        return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
                    });
                }
            } else if (methodInput == 'Kolay-Zor') {
                if (this.wordList.length > 1) {
                    this.wordList.sort(function (a, b) {
                        return a.difficulty - b.difficulty;
                    });
                }
            } else if (methodInput == 'Zor-Kolay') {
                if (this.wordList.length > 1) {
                    this.wordList.sort(function (a, b) {
                        var textA = a.difficulty;
                        var textB = b.difficulty;
                        return (textA > textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                }
            }

        },
        speak(text) {
            // text to speech için voice listesi
            var voice = speechSynthesis.getVoices().filter(function (el) {
                return el.name == "Microsoft Zira - English (United States)"
            });

            var synthesis = window.speechSynthesis;
            // Set utterance properties
            var utterance = new SpeechSynthesisUtterance(text);

            utterance.lang = "en-US"; // required for Android Chrome
            utterance.voiceURI = "Microsoft Zira - English (United States)";
            utterance.pitch = 0.9; // ton
            utterance.rate = 0.9; // hız
            utterance.volume = 1; // şiddet
            utterance.voice = voice[0]; // required for iOS


            synthesis.speak(utterance);
        },
        deleteWord(word) {
            const body_data = [word.id]
            if (this.isPathKnownList) {
                axios.post("/api/WordList/DeleteWordsFromKnownlist", body_data)
                let userData = this.$store.getters.getUserData
                userData.knownList.splice(userData.knownList.findIndex(item => item.id === word.id), 1)
                this.$store.commit("updateUserData", userData)
            } else {
                this.wordList.splice(this.wordList.indexOf(word), 1)
                axios.post("/api/WordList/DeleteWordsFromWordlist?wordListId=" + this.$store.getters.getSelectedListId, body_data)
            }

        },
        goQuiz() {
            if (this.quizList.length > 5) {
                this.$store.commit("setQuizList", this.quizList)
                // kaldığım yerden devam et
                this.$store.commit("set_history_start_length", this.quizList.length)
                this.$router.push(this.$store.getters.getLocaleLink('/quiz'))
            } else {
                alert(this.$t("quiz.minimum_word_count"))
            }

        },
        toggleRemove(phrase) {
            const index = this.removedPhrases.indexOf(phrase);
            if (index > -1) {
                this.removedPhrases.splice(index, 1);
            } else {
                this.removedPhrases.push(phrase)
            }
        },
        addList(list_id) {
            this.$store.commit('setShowNewListModal', false)
            axios
                .post("/api/WordList/AddWordsToWordlist?wordListId=" + list_id, [this.hovered_word.id])
                .then((response) => {
                })
        },

    },
    updated() {
        // this.changeSortMethod('A-Z')
        // this.removedPhrases = JSON.parse(JSON.stringify(this.$store.getters.getUserData.knownList))

    },
    watch: {
        selectAll() {
            if (this.selectAll) {
                this.removedPhrases = []
            } else {
                this.removedPhrases = this.wordList2.map(v => v.phrase)
            }
        }
    },
    computed: {
        wordList2() {

            // prop dan gelen listeyi kaybetmemek için böyle yapmak zorunda kaldık.
            let tmp = this.wordList.filter((el) => {
                return this.sliderValue[0] <= el.difficulty &&
                    el.difficulty <= this.sliderValue[1]
                    ;
            });
            return tmp
        },
        quizList() {
            // console.log(this.removedPhrases)
            // console.log(this.wordListData.words)
            // this.wordListData.words = JSON.parse(JSON.stringify(this.wordListData.words))
            if (this.wordList2) {
                let tmp_list = this.wordList2.filter((el) => {
                    return !this.removedPhrases.includes(el.phrase)
                });

                return tmp_list;
            } else {
                let tmp_list = []
                return tmp_list;
            }
            // let tmp_list = this.wordList.filter(({ phrase: id1 }) => !this.removedPhrases.some(({ phrase: id2 }) => id2 === id1));
            // tmp_list = JSON.parse(JSON.stringify(tmp_list))

        }

    }
}
</script>
<style scoped>
@charset "UTF-8";
@import "@vueform/slider/themes/default.css";

.my-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0;
    padding: 0;
}

.difficulty-bar {
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background: var(--Lightest-Gray, #FBFBFB);
    box-shadow: 0px 4px 4px 0px #D9D9D9;
    padding: 24px 48px;
}

.difficulty-bar .text {
    color: var(--Black-Gray, #696969);
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
}

.difficultyLevels {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: space-between;
    list-style: none;
    width: 100%;
    margin-top: 10px;
    font-weight: 700;
    text-transform: uppercase;
}

.difficultyLevels li:nth-child(1) {
    color: var(--Green---Success, #A6D296);
    ;
}

.difficultyLevels li:nth-child(2) {
    color: var(--Green---Success, #A6D296);

}

.difficultyLevels li:nth-child(3) {
    color: var(--Gray, #B7B7B7);

}

.difficultyLevels li:nth-child(4) {
    color: var(--Secondary, #DC8989);

}

.difficultyLevels li:nth-child(5) {
    color: var(--Darker-Secondary, #B26C6C);
}

.newSlider {
    --slider-connect-bg: var(--Primary, #8887C6);
    --slider-tooltip-bg: var(--Primary, #8887C6);
    --slider-tooltip-color: #FFF;
    --slider-handle-ring-color: var(--Primary, #8887C6);
    --slider-height: 24px;
    --slider-handle-bg: var(--Primary, #8887C6);
    --slider-handle-width: 36px;
    --slider-handle-height: 36px;
    --slider-tooltip-min-width: 82px;
    --slider-tooltip-radius: 80px;
    --slider-tooltip-py: 8px;
    --slider-tooltip-px: 14px;
}

.go-quiz {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: var(--Lightest-Gray, #FBFBFB);
    box-shadow: 0px 4px 4px 0px #D9D9D9;
    width: 337px;
    height: 144px;
    cursor: pointer;
    position: -webkit-sticky;
    position: sticky;
    bottom: 24px;
    align-self: flex-end;
    justify-self: flex-end;
}

.go-quiz:hover {
    background: var(--Light-Tertiary, #FFFAEB);
}

.go-quiz .text {
    display: flex;
    flex-direction: column;
}

.go-quiz .text .title {
    color: var(--Primary, #8887C6);
    text-align: center;
    /* WEB/Headline Large */
    font-family: Urbanist;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.go-quiz .text .description {
    color: var(--Secondary, #DC8989);
    text-align: center;
    /* WEB/Label Small */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.go-quiz .icon {
    width: 300px;
}

.go-quiz .icon svg {
    padding: 0;
    margin: 0;
}

.wordlist {
    margin-top: 48px;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 24px;
}

.wordlist .header {
    display: flex;
    flex-direction: row;
    height: 60px;
    position: relative;
}

.wordlist .header .title {
    color: var(--dark, #4F4F4F);
    text-align: center;
    /* WEB/Title Large */
    font-family: Poppins;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    align-self: flex-start;
    justify-self: flex-start;
    text-align: start;
    position: absolute;
    left: 40%;
}

.wordlist .header .total-word-count {
    color: var(--dark, #4F4F4F);
    /* WEB/Body Medium */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    align-self: center;
    position: absolute;
    left: 5%;
}

.wordlist .header .sort-icon {
    position: absolute;
    right: 2%;
    top: 30%;
    cursor: pointer;
}

.wordlist .sort-methods {
    display: none;
}

.wordlist .sort-methods span {
    color: #4F4F4F;
    padding: 16px 32px;
    text-align: center;
    font-size: 20px;
    cursor: pointer;
}

.wordlist .sort-methods span:hover {
    background: var(--Light-Gray, #E8E8E8);
}

.sort-icon:hover+.sort-methods,
.sort-methods:hover {
    display: flex;
    flex-direction: column;
    background: var(--Lightest-Gray, #FBFBFB);
    position: absolute;
    right: 2%;
    top: 40px;
    z-index: 2;
}



.wordlist .my-table {
    display: flex;
    flex-direction: column;
}

.wordlist .my-table tr {
    display: flex;
    flex-direction: row;
    border-radius: 10px;
    box-shadow: 0px 4px 4px 0px #D9D9D9;
    width: 100%;
    min-height: 72px;
    max-height: 100%;
    position: relative;
    cursor: pointer;

}


.wordlist .my-table tr:nth-child(odd) {
    background: var(--Lightest-Gray, #FBFBFB);

}

.wordlist .my-table tr:nth-child(even) {
    background: var(--Light-Gray, #E8E8E8);

}

.wordlist .my-table tr .grid {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 33px;
    height: 100%;
}

.wordlist .my-table tr .grid span {
    color: var(--Dark, #4F4F4F);
    /* WEB/Body Large */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.wordlist .my-table tr .grid .en-mean {
    font-size: 14px;
}

.wordlist .my-table tr .grid:nth-child(1) {
    position: absolute;
    left: 2%;
}

.wordlist .my-table tr .grid:nth-child(1) span {
    max-width: 200px;
}

.wordlist .my-table tr .grid:nth-child(2) {
    position: absolute;
    max-width: 284px;
    left: 40%;
}

.wordlist .my-table tr .grid:nth-child(3) {
    position: absolute;
    right: 2%;

}

.wordlist .my-table tr .grid img {
    cursor: pointer;
}

.wordlist .my-table tr .grid input,
label {
    cursor: pointer;
}

.add-drop input[type=checkbox] {
    display: none;
}

.add-drop input[type=checkbox]+label {
    background-image: url("@/assets/SeriesDetail/added.svg");
    background-repeat: no-repeat;
    background-position: center;
    height: 30px;
    width: 36px;
    display: inline-block;
}

.add-drop input[type=checkbox]:checked+label {
    background-image: url("@/assets/SeriesDetail/dropped.svg");
    background-repeat: no-repeat;
    background-position: center;
    height: 30px;
    width: 36px;
    display: inline-block;
}

.tooltip2 {
    position: relative;
    display: inline-block;
}

.tooltip2 .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #A6D296;
    color: #F2F2F2 !important;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    width: 120px;
    bottom: 100%;
    left: 50%;
    margin-left: -60px;
    /* Use half of the width (120/2 = 60), to center the tooltip */

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
}

.tooltip2:hover .tooltiptext {
    visibility: visible;
}

.sample-sentence {
    border-radius: 8px;
    background: var(--Lightest-Gray, #FBFBFB);
    box-shadow: 0px 4px 4px 0px #D9D9D9;
    position: fixed;
    bottom: 24px;
    width: 450px;
    height: 144px;
    position: sticky;
    z-index: 99;
    justify-self: flex-end;
}

.plus-container {
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    padding: 20px
}

.sample-sentence .plus-container span {
    font-size: 24px;
    text-align: center;
    color: #4F4F4F;
    align-self: center;
    justify-self: center;
}

.plus {
    position: absolute;
    cursor: pointer;
    top: 8px;
    left: 8px;
}

.take_break {
    position: absolute;
    cursor: pointer;
    top: 2px;
    right: 8px;
}

.my-row-flex {
    display: flex;
    flex-direction: row;
    gap: 8px;
}

.my-column-flex {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

@media (max-width: 600px) {
    .difficulty-bar {
        padding: 16px 30px;
    }

    .difficultyLevels li {
        font-size: 10px;
    }

    .difficulty-bar .text {
        font-size: 16px;
    }

    .go-quiz {
        width: 192px;
        height: 82px;
        bottom: 8px;
    }

    .go-quiz .text {
        padding: 0px;
    }

    .go-quiz .text .title {
        font-size: 14px;
        padding: 0px 10px;
    }

    .go-quiz .text .description {
        font-size: 10px;
        padding: 0px 10px;
    }

    .wordlist .header .title {
        font-size: 20px;
    }

    .wordlist .my-table tr .grid span {
        font-size: 12px;
    }

    .wordlist .my-table tr .grid .en-mean {
        font-size: 10px;
    }

    .wordlist .my-table tr .grid:nth-child(2) {
        max-width: 134px;
    }


    .wordlist .my-table tr .grid:nth-child(1) span {
        max-width: 75px;
    }

    .wordlist .my-table tr .grid {
        gap: 8px;
    }

    .newSlider {
        --slider-tooltip-min-width: 62px;
        --slider-tooltip-radius: 80px;
        --slider-tooltip-py: 4px;
        --slider-tooltip-px: 8px;
    }

    .wordlist .header .total-word-count {
        font-size: 11px;
        left: 8%;
    }

    .sample-sentence {
        border-radius: 8px;
        bottom: 100px;
        width: 95%;
        height: 100px;
    }

    .sample-sentence .plus-container span {
        font-size: 14px;
    }

    .take_break {
        font-size: 2px;
    }

}
</style>